module.exports = __webpack_public_path__ + "img/Crop.3921b88b.svg";